import { PaletteUtils } from '@shared/utils';
import { ColorsEnum, Text } from '@shared/widgets';

interface RecentRecipientIconProps {
  firstName?: string;
  lastName?: string;
  companyName?: string;
  accountNumber?: string;
  iban?: string;
}

export const RecentRecipientIcon = (props: RecentRecipientIconProps) => {
  return (
    <>
      <div className='mr-2 flex h-9 min-h-9 w-9 min-w-9 rounded-full bg-primary'>
        <Text weight='semibold' className='m-auto' color={ColorsEnum.White}>
          {props?.firstName?.[0]} {props?.lastName?.[0]}
          {!props?.firstName?.[0] && !props?.lastName?.[0] && (props?.companyName?.[0] || '-')}
        </Text>
      </div>
      <div className='flex flex-col'>
        <Text weight='semibold'>
          {props.firstName} {props.lastName} {props.companyName}
          {!props.firstName && !props.lastName && !props.companyName && '-'}
        </Text>
        <Text className='text-nowrap' size='xs' color={PaletteUtils.isInsigniaPalette ? ColorsEnum.Secondary : ColorsEnum.Gray}>
          {props.iban || props.accountNumber}
        </Text>
      </div>
    </>
  );
};
